import { jsxs as a, jsx as i } from "react/jsx-runtime";
import { Tag as n } from "./designsystem-ui-react40.js";
import p from "./designsystem-ui-react100.js";
function l({
  value: e,
  suffix: r,
  icon: o = /* @__PURE__ */ i(p, {}),
  size: m = "regular",
  className: t
}) {
  return /* @__PURE__ */ a(n, { className: t, icon: o, size: m, variant: "base", children: [
    e,
    r ? ` ${r}` : ""
  ] });
}
export {
  l as CardTime
};
